// import React, { useState, useEffect } from 'react';
// import { toast } from 'react-toastify';
// import {
//     Box,
//     Typography,
//     Paper,
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     IconButton,
//     Chip,
//     ThemeProvider,
//     createTheme,
//     TextField,
//     FormControl,
//     InputLabel,
//     Select,
//     MenuItem,
//     CircularProgress,
//     Button,
// } from '@mui/material';
// import EditIcon from '@mui/icons-material/Edit';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import DeleteIcon from '@mui/icons-material/Delete';
// import { useNavigate } from 'react-router-dom';
// import SweetAlert from '../utils/sweetAlert';
// import { useAuth } from '../hooks/useAuth';
// import Can from './permissions/Can';

// // 🎨 Custom Theme
// const revivePayTheme = createTheme({
//     palette: {
//         primary: { main: '#0a3d62' },
//         success: { main: '#4caf50' },
//         error: { main: '#d32f2f' },
//     },
// });

// const UserTableList = () => {
//     const { user, hasPermission } = useAuth();


//     const canViewUserList = hasPermission('user-list');
//     const canCreateUser = hasPermission('user-create');
//     const canEditUser = hasPermission('user-edit');
//     const canViewUser = hasPermission('user-view');
//     const canDeleteUser = hasPermission('user-delete');


//     const navigate = useNavigate();
//     const [users, setUsers] = useState([]);
//     const [isLoading, setIsLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [filterRole, setFilterRole] = useState('all');
//     const [availableRoles, setAvailableRoles] = useState(['all']);

//     useEffect(() => {
//         const fetchUsers = async () => {
//             if (!canViewUserList) {
//                 toast.error('You do not have permission to view users.');
//                 return;
//             }
//             setIsLoading(true);
//             try {
//                 const params = { 'relations[]': ['status', 'roles'], paginate: 1 };
//                 const userData = await GetUsersList(params);
//                 setUsers(userData?.list || []);

//                 const roleNames = ['all', ...new Set(userData?.list?.map(user => user.roles[0]?.name).filter(Boolean))];
//                 setAvailableRoles(roleNames);
//                 setError(null);
//             } catch (err) {
//                 console.error("Fetch users error:", err);
//                 setError('Failed to load users. Please check your network or API.');
//                 toast.error('Failed to load users.');
//             } finally {
//                 setIsLoading(false);
//             }
//         };
//         fetchUsers();
//     }, []);

//     const filteredUsers = users.filter(user => {
//         const lowerCaseSearch = searchTerm.toLowerCase();
//         const roleMatch = filterRole === 'all' || user.roles[0]?.name === filterRole;
//         const searchMatch =
//             user.name.toLowerCase().includes(lowerCaseSearch) ||
//             user.email.toLowerCase().includes(lowerCaseSearch);
//         return roleMatch && searchMatch;
//     });

//     const handleEdit = (userId) => {
//         if (!canEditUser) return;
//         navigate(`${CREATE_USER}?edit_id=${userId}`);
//     };

//     const handleView = (userId) => {
//         if (!canViewUser) return;
//         navigate(`${CREATE_USER}?view=${userId}`);
//     };


//     const handleDelete = async (userId) => {
//         if (!canDeleteUser) return;
//         try {
//             // Show SweetAlert confirmation
//             const result = await SweetAlert.deleteConfirm(user.name || 'This User');

//             // If user cancels, return early
//             if (!result.isConfirmed) {
//                 return;
//             }

//             const response = await DeleteUser(userId);

//             // console.log(response, 'for checking purpose');

//             if (response?.data?.success) {
//                 // SweetAlert success
//                 await SweetAlert.success({
//                     text: 'Users record deleted successfully.'
//                 });
//                 setUsers(users.filter(user => user.id !== userId));
//             } else {
//                 // SweetAlert error
//                 await SweetAlert.error({
//                     text: response?.data?.message || 'Failed to delete User record'
//                 });
//             }
//         } catch (error) {
//             console.error('Delete action error:', error);
//             await SweetAlert.error({
//                 text: 'Failed to delete DBA record'
//             });
//         }
//     };


//     const getStatusChip = (status) => {
//         const normalizedStatus = status ? status.toLowerCase() : 'inactive';
//         const color = normalizedStatus === 'active' ? 'success' : 'error';
//         const label = normalizedStatus === 'active' ? 'Active' : 'Inactive';
//         return (
//             <Chip
//                 label={label}
//                 color={color}
//                 size="small"
//                 sx={{ textTransform: 'capitalize', fontWeight: 'bold' }}
//             />
//         );
//     };

//     const formatGender = (gender) => {
//         switch (gender) {
//             case 'M': return 'Male';
//             case 'F': return 'Female';
//             case 'O': return 'Other';
//             default: return 'Not Specified';
//         }
//     };

//     return (
//         <ThemeProvider theme={revivePayTheme}>
//             <Box sx={{ flexGrow: 1, p: 4, bgcolor: '#fff' }}>
//                 <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
//                     <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
//                         User List
//                     </Typography>
//                     <Can permission='user-create'>
//                         <Button
//                             variant="contained"
//                             color="primary"
//                             onClick={() => navigate(CREATE_USER)}
//                             disabled={isLoading}
//                         >
//                             Add New User
//                         </Button>
//                     </Can>
//                 </Box>

//                 <Box sx={{
//                     display: 'flex',
//                     gap: 3,
//                     mb: 3,
//                     flexWrap: 'wrap',
//                     alignItems: 'center',
//                     p: 2,
//                     bgcolor: 'white',
//                     borderRadius: 2,
//                     boxShadow: 1,
//                 }}>
//                     <TextField
//                         label="Search Name or Email"
//                         variant="outlined"
//                         size="small"
//                         value={searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                         sx={{ minWidth: 250 }}
//                         disabled={isLoading}
//                     />
//                     <FormControl size="small" sx={{ minWidth: 150 }} disabled={isLoading}>
//                         <InputLabel id="role-filter-label">Filter by Role</InputLabel>
//                         <Select
//                             labelId="role-filter-label"
//                             value={filterRole}
//                             label="Filter by Role"
//                             onChange={(e) => setFilterRole(e.target.value)}
//                             sx={{ borderRadius: 2 }}
//                             searchable={true}
//                         >
//                             {availableRoles.map(role => (
//                                 <MenuItem key={role} value={role}>
//                                     {role === 'all' ? 'All Roles' : role}
//                                 </MenuItem>
//                             ))}
//                         </Select>
//                     </FormControl>
//                 </Box>

//                 {isLoading && (
//                     <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
//                         <CircularProgress color="primary" />
//                     </Box>
//                 )}
//                 {!isLoading && error && (
//                     <Typography color="error" align="center" sx={{ my: 4 }}>
//                         {error}
//                     </Typography>
//                 )}
//                 {!isLoading && !error && filteredUsers.length === 0 && (
//                     <Typography align="center" sx={{ my: 4 }}>
//                         No users found matching your criteria.
//                     </Typography>
//                 )}

//                 {!isLoading && !error && filteredUsers.length > 0 && (
//                     <Paper elevation={1} sx={{ borderRadius: 2 }}>
//                         <TableContainer>
//                             <Table stickyHeader aria-label="user list table">
//                                 <TableHead>
//                                     <TableRow sx={{
//                                         bgcolor: revivePayTheme.palette.primary.main,
//                                         '& th': { color: 'black', fontWeight: 'bold' },
//                                     }}>
//                                         {/* <TableCell>ID</TableCell> */}
//                                         <TableCell>Name</TableCell>
//                                         <TableCell>Email</TableCell>
//                                         <TableCell>Role</TableCell>
//                                         <TableCell>Status</TableCell>
//                                         <TableCell>Gender</TableCell>
//                                         <TableCell align="center">Actions</TableCell>
//                                     </TableRow>
//                                 </TableHead>
//                                 <TableBody>
//                                     {filteredUsers.map((user) => (
//                                         <TableRow
//                                             key={user.id}
//                                             hover
//                                             sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
//                                         >
//                                             {/* <TableCell component="th" scope="row">
//                                                 {user.id ? `${user.id.slice(0, 2)}...` : 'N/A'}
//                                             </TableCell> */}
//                                             <TableCell>{user.name}</TableCell>
//                                             <TableCell>{user.email}</TableCell>
//                                             <TableCell>{user.roles[0]?.name || 'N/A'}</TableCell>
//                                             <TableCell>{getStatusChip(user.status?.name)}</TableCell>
//                                             {/* <TableCell>{user.phone || 'N/A'}</TableCell> */}
//                                             <TableCell>{formatGender(user.gender)}</TableCell>
//                                             <TableCell align="center">
//                                                 <Can permission='user-view'>
//                                                     <IconButton
//                                                         onClick={() => handleView(user.id)}
//                                                         aria-label="view user"
//                                                         color="primary"
//                                                         size="small"
//                                                     >
//                                                         <VisibilityIcon />
//                                                     </IconButton>
//                                                 </Can>
//                                                 <Can permission='user-edit'>
//                                                     <IconButton
//                                                         onClick={() => handleEdit(user.id)}
//                                                         aria-label="edit user"
//                                                         color="success"
//                                                         size="small"
//                                                     >
//                                                         <EditIcon />
//                                                     </IconButton>
//                                                 </Can>
//                                                 <Can permission='user-delete'>
//                                                     <IconButton
//                                                         onClick={() => handleDelete(user.id)}
//                                                         aria-label="delete user"
//                                                         color="error"
//                                                         size="small"
//                                                     >
//                                                         <DeleteIcon />
//                                                     </IconButton>
//                                                 </Can>
//                                             </TableCell>
//                                         </TableRow>
//                                     ))}
//                                 </TableBody>
//                             </Table>
//                         </TableContainer>
//                     </Paper>
//                 )}
//             </Box>
//         </ThemeProvider>
//     );
// };

// export default UserTableList;



import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { getUsersList, deleteUser } from '../store/slices/userSlice';
import {
    Box,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Chip,
    ThemeProvider,
    createTheme,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    CircularProgress,
    Button,
    TablePagination,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import { CREATE_USER, USERS_LIST_PATH } from '../navigations/path';
import SweetAlert from '../utils/sweetAlert';
import { useAuth } from '../hooks/useAuth';
import Can from './permissions/Can';

// 🎨 Custom Theme
const revivePayTheme = createTheme({
    palette: {
        primary: { main: '#0a3d62' },
        success: { main: '#4caf50' },
        error: { main: '#d32f2f' },
    },
});

const UserTableList = () => {
    const dispatch = useDispatch();
    const { hasPermission, hasAnyPermission } = useAuth();

    const canViewUserList = hasAnyPermission(['user-list', 'user-direct-permission']);
    const canCreateUser = hasPermission('user-create');
    const canEditUser = hasPermission('user-edit');
    const canViewUser = hasPermission('user-view');
    const canDeleteUser = hasPermission('user-delete');

    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [filterRole, setFilterRole] = useState('all');
    const [availableRoles, setAvailableRoles] = useState(['all']);
    const [page, setPage] = useState(0); // For Pagination
    const [rowsPerPage, setRowsPerPage] = useState(10); // Number of rows per page

    useEffect(() => {
        const fetchUsers = async () => {
            if (!canViewUserList) {
                toast.error('You do not have permission to view users.');
                return;
            }
            setIsLoading(true);
            try {
                const params = { 'relations[]': ['status', 'roles'] };
                const userData = await dispatch(getUsersList(params)).unwrap();
                const list = userData?.list ?? userData ?? [];
                setUsers(Array.isArray(list) ? list : []);
                const roleNames = ['all', ...new Set(list?.map(u => u.roles?.[0]?.name).filter(Boolean))];
                setAvailableRoles(roleNames);
                setError(null);
            } catch (err) {
                console.error("Fetch users error:", err);
                setError('Failed to load users. Please check your network or API.');
                toast.error('Failed to load users.');
            } finally {
                setIsLoading(false);
            }
        };
        fetchUsers();
    }, []);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to first page
    };

    const filteredUsers = users.filter(user => {
        const lowerCaseSearch = searchTerm.toLowerCase();
        const roleMatch = filterRole === 'all' || user.roles[0]?.name === filterRole;
        const searchMatch =
            user.name.toLowerCase().includes(lowerCaseSearch) ||
            user.email.toLowerCase().includes(lowerCaseSearch);
        return roleMatch && searchMatch;
    });

    const handleEdit = (userId) => {
        if (!canEditUser) return;
        navigate(`${CREATE_USER}?edit_id=${userId}`);
    };

    const handleView = (userId) => {
        if (!canViewUser) return;
        navigate(`${CREATE_USER}?view=${userId}`);
    };

    const handleDelete = async (userId) => {
        if (!canDeleteUser) return;
        try {
            const targetUser = users.find(u => u.id === userId);
            const result = await SweetAlert.deleteConfirm(targetUser?.name || 'This User');

            // If user cancels, return early
            if (!result.isConfirmed) {
                return;
            }

            await dispatch(deleteUser(userId)).unwrap();
            await SweetAlert.success({
                text: 'Users record deleted successfully.'
            });
            setUsers(users.filter(u => u.id !== userId));
        } catch (error) {
            console.error('Delete action error:', error);
            await SweetAlert.error({
                text: 'Failed to delete DBA record'
            });
        }
    };

    const getStatusChip = (status) => {
        const normalizedStatus = status ? status.toLowerCase() : 'inactive';
        const color = normalizedStatus === 'active' ? 'success' : 'error';
        const label = normalizedStatus === 'active' ? 'Active' : 'Inactive';
        return (
            <Chip
                label={label}
                color={color}
                size="small"
                sx={{ textTransform: 'capitalize', fontWeight: 'bold' }}
            />
        );
    };

    const formatGender = (gender) => {
        switch (gender) {
            case 'M': return 'Male';
            case 'F': return 'Female';
            case 'O': return 'Other';
            default: return 'Not Specified';
        }
    };

    return (
        <ThemeProvider theme={revivePayTheme}>
            <Box sx={{ flexGrow: 1, p: 4, bgcolor: '#fff' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
                    <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
                        User List
                    </Typography>
                    <Can permission='user-create'>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => navigate(CREATE_USER)}
                            disabled={isLoading}
                        >
                            Add New User
                        </Button>
                    </Can>
                </Box>

                <Box sx={{
                    display: 'flex',
                    gap: 3,
                    mb: 3,
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    p: 2,
                    bgcolor: 'white',
                    borderRadius: 2,
                    boxShadow: 1,
                }}>
                    <TextField
                        label="Search Name or Email"
                        variant="outlined"
                        size="small"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        sx={{ minWidth: 250 }}
                        disabled={isLoading}
                    />
                    <FormControl size="small" sx={{ minWidth: 150 }} disabled={isLoading}>
                        <InputLabel id="role-filter-label">Filter by Role</InputLabel>
                        <Select
                            labelId="role-filter-label"
                            value={filterRole}
                            label="Filter by Role"
                            onChange={(e) => setFilterRole(e.target.value)}
                            sx={{ borderRadius: 2 }}
                        >
                            {availableRoles.map(role => (
                                <MenuItem key={role} value={role}>
                                    {role === 'all' ? 'All Roles' : role}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>

                {isLoading && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                        <CircularProgress color="primary" />
                    </Box>
                )}
                {!isLoading && error && (
                    <Typography color="error" align="center" sx={{ my: 4 }}>
                        {error}
                    </Typography>
                )}
                {!isLoading && !error && filteredUsers.length === 0 && (
                    <Typography align="center" sx={{ my: 4 }}>
                        No users found matching your criteria.
                    </Typography>
                )}

                {!isLoading && !error && filteredUsers.length > 0 && (
                    <Paper elevation={1} sx={{ borderRadius: 2 }}>
                        <TableContainer sx={{ maxHeight: 400 }}>
                            <Table stickyHeader aria-label="user list table">
                                <TableHead>
                                    <TableRow sx={{
                                        bgcolor: revivePayTheme.palette.primary.main,
                                        '& th': { color: 'black', fontWeight: 'bold' },
                                    }}>
                                        <TableCell>Name</TableCell>
                                        <TableCell>Email</TableCell>
                                        <TableCell>Role</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell>Gender</TableCell>
                                        <TableCell align="center">Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((user) => (
                                        <TableRow
                                            key={user.id}
                                            hover
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell>{user.name}</TableCell>
                                            <TableCell>{user.email}</TableCell>
                                            <TableCell>{user.roles[0]?.name || 'N/A'}</TableCell>
                                            <TableCell>{getStatusChip(user.status?.name)}</TableCell>
                                            <TableCell>{formatGender(user.gender)}</TableCell>
                                            <TableCell align="center">
                                                <Can permission='user-view'>
                                                    <IconButton
                                                        onClick={() => handleView(user.id)}
                                                        aria-label="view user"
                                                        color="primary"
                                                        size="small"
                                                    >
                                                        <VisibilityIcon />
                                                    </IconButton>
                                                </Can>
                                                <Can permission='user-edit'>
                                                    <IconButton
                                                        onClick={() => handleEdit(user.id)}
                                                        aria-label="edit user"
                                                        color="success"
                                                        size="small"
                                                    >
                                                        <EditIcon />
                                                    </IconButton>
                                                </Can>
                                                <Can permission='user-delete'>
                                                    <IconButton
                                                        onClick={() => handleDelete(user.id)}
                                                        aria-label="delete user"
                                                        color="error"
                                                        size="small"
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Can>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={filteredUsers.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Paper>
                )}
            </Box>
        </ThemeProvider>
    );
};

export default UserTableList;
